import { ref, readonly } from "vue";
import { getPaymentDetail } from "../api";
import type { PaymentsLogDetail } from "@/api/model";

export function usePaymentDetail() {
  const paymentDetail = ref<PaymentsLogDetail | null>(null);
  const isLoading = ref(false);
  const fetchError = ref(false);

  async function fetchPaymentById(paymentId: string) {
    isLoading.value = true;
    fetchError.value = false;
    paymentDetail.value = null;

    try {
      const result = await getPaymentDetail(paymentId);

      if ("error" in result) {
        fetchError.value = true;
      } else {
        paymentDetail.value = result;
      }
    } catch (err) {
      fetchError.value = true;
      console.error("Fetch payment detail exception:", err);
    } finally {
      isLoading.value = false;
    }
  }

  return {
    paymentDetail: readonly(paymentDetail),
    isLoading: readonly(isLoading),
    fetchError: readonly(fetchError),
    fetchPaymentById,
  };
}
